<div class="d-flex flex-column justify-content-center align-items-center h-100" style="background-color: white">
    <ng-container *ngIf="downloadUrl !== null">
        <button mat-flat-button color="primary" class="mb--16" (click)="clear()">Clear</button>
        <iframe [src]="downloadUrl" class="flex-fill w-100" frameborder="0"></iframe>
    </ng-container>

    <ng-container *ngIf="error !== null">
        <h4>{{ error }}</h4>
        <button mat-flat-button color="primary" (click)="clear()">Clear</button>
    </ng-container>

    <ng-container *ngIf="downloadUrl === null && error === null">
        <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <input type="file" style="height: unset !important" (change)="handleFileInput($event.target!)">
            <button mat-flat-button color="primary" (click)="testFile()" [disabled]="file === null || loading">Test</button>
        </div>
    </ng-container>
</div>